export enum NewsCategory {
    Hires = "hires",
    Promotes = "promotes",
    Leaves = "leaves",
    Retires = "retires_from",
    Acquires = "acquires",
    MergesWith = "merges_with",
    SellsAssetsTo = "sells_assets_to",
    ExpandsOfficesTo = "expands_offices_to",
    ExpandsOfficesIn = "expands_offices_in",
    ExpandsFacilities = "expands_facilities",
    OpensNewLocation = "opens_new_location",
    IncreasesHeadcountBy = "increases_headcount_by",
    AttendsEvent = "attends_event",
    Launches = "launches",
    IntegratesWith = "integrates_with",
    IsDeveloping = "is_developing",
    ReceivesFinancing = "receives_financing",
    InvestsInto = "invests_into",
    InvestsIntoAssets = "invests_into_assets",
    GoesPublic = "goes_public",
    ClosesOffices = "closes_offices_in",
    DecreasesHeadcountBy = "decreases_headcount_by",
    PartnersWith = "partners_with",
    SignsNewClient = "signs_new_client",
    FilesSuitAgainst = "files_suit_against",
    HasIssuesWith = "has_issues_with",
    IdentifiedAsCompetitorOf = "identified_as_competitor_of",
    EndsPartnershipWith = "ends_partnership_with",
    LosesClient = "loses_client",
    HasEarnings = "has_earnings",
    HasRevenue = "has_revenue",
    HasValuation = "has_valuation",
    DeclaresBankruptcy = "declares_bankruptcy",
    SpinsOffCompany = "spins_off_company",
    SpinsOffDivision = "spins_off_division",
    ReceivesAward = "receives_award",
    RecognizedAs = "recognized_as",
}
